import React from 'react';
const frictions = ['Another class to build.', 'Another set of exercises to find.', 'Another group with different ability levels.', 'Another progression to organize.', 'Another week wondering what comes next.'];
export function ProblemSection() {
  return <section className="bg-ivory px-4 sm:px-6 py-9 sm:py-12" data-id="element-141" data-mp="2vqhh2ecujw0x">
      <div className="max-w-3xl mx-auto" data-id="element-142" data-mp="2vownos29qj4n">
        <h2 className="font-heading font-extrabold uppercase text-lg sm:text-2xl leading-tight tracking-tight text-petrol text-center mb-2" data-id="element-143" data-mp="39hw2ssy52bbo">
          You already know how to coach.
        </h2>
        <p className="font-heading font-semibold uppercase text-[11px] sm:text-sm tracking-wide text-green-dark text-center leading-snug mb-6 max-w-xl mx-auto" data-id="element-144" data-mp="3jg1yutx9kn8m">
          The problem is everything you have to prepare before the class even
          starts.
        </p>

        <ul className="max-w-md mx-auto mb-6" data-id="element-145" data-mp="1p2atw7pvqrji">
          {frictions.map(item => <li key={item} className="flex items-baseline gap-2.5 border-b border-petrol/10 py-2 last:border-b-0" data-id="element-146" data-mp="1k4it0o79bv36">
              <span className="text-green font-heading font-black text-sm leading-none shrink-0" data-id="element-147" data-mp="obonsnf6qvfv">
                ×
              </span>
              <span className="text-[13px] sm:text-base font-medium text-petrol/80" data-id="element-148" data-mp="sc8kxqzrdz20">
                {item}
              </span>
            </li>)}
        </ul>

        <p className="text-[13px] sm:text-base text-petrol/75 leading-relaxed text-center max-w-xl mx-auto mb-5" data-id="element-149" data-mp="124eayv6ga6ek">
          Your expertise shouldn't require you to rebuild your entire planning
          process every single week.
        </p>

        <p className="font-heading font-extrabold uppercase text-sm sm:text-lg leading-tight tracking-tight text-petrol text-center border-t-2 border-lime pt-5 max-w-lg mx-auto" data-id="element-150" data-mp="1c2ka550vgyfq">
          Your next class doesn't need to start with a blank page.
        </p>
      </div>
    </section>;
}